var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCordova(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M727.3,780.8H597.7l9.1-109.1h-63.6l-9.1,109.1H265.9l-9.1-109.1h-63.6l9.1,109.1H72.7L0,308.1L181.8,17.2 h436.4L800,308.1L727.3,780.8z M581.8,162.6H464.9l7.8,54.5H327.3l7.8-54.5H218.2l-72.7,145.5L181.8,599h436.4l36.4-290.9 L581.8,162.6z M518.2,502.5c-10,0-18.2-30.3-18.2-67.6s8.1-67.6,18.2-67.6c10,0,18.2,30.3,18.2,67.6S528.2,502.5,518.2,502.5z  M288.6,508.1c-10,0-18.2-30.3-18.2-67.6s8.1-67.6,18.2-67.6c10,0,18.2,30.3,18.2,67.6S298.7,508.1,288.6,508.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCordova);
export default __webpack_public_path__ + "static/media/cordova.305dfe4b4f8891cb502841bae237f915.svg";
export { ForwardRef as ReactComponent };